module.exports = __webpack_public_path__ + "img/allgemeine-struktur.efa3108c.png";